module.exports = __webpack_public_path__ + "static/img/exam-9-bg.109cff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-9-bg.png
// module id = 8XUE
// module chunks = 1